import { RolPlataforma } from '../models/novedades.models';

export interface RoleOption {
  key: RolPlataforma;
  label: string;
  route: string;
}

export const ROLE_OPTIONS: RoleOption[] = [
  { key: 'administrador_anid', label: 'Administrador ANID', route: '/principal' },
  { key: 'postulante', label: 'Postulante', route: '/principal' },
  { key: 'ayudante_postulante', label: 'Ayudante de postulante', route: '/principal' },
  { key: 'representante_institucional', label: 'Representante institucional', route: '/inicio' },
  { key: 'ayudante_representante', label: 'Ayudante de representante', route: '/inicio' },
  { key: 'recomendador', label: 'Recomendador', route: '/inicio' },
  { key: 'urc', label: 'URC', route: '/inicio' },
  { key: 'analista', label: 'Analista', route: '/inicio' },
];

export const ROLES_CON_NOTIFICACIONES: RolPlataforma[] = [
  'postulante',
  'ayudante_postulante',
  'representante_institucional',
  'ayudante_representante',
  'recomendador',
];

export function routeForRole(role: RolPlataforma): string {
  return ROLE_OPTIONS.find((item) => item.key === role)?.route ?? '/principal';
}

export function roleHasNotifications(role: RolPlataforma): boolean {
  return ROLES_CON_NOTIFICACIONES.includes(role);
}
